<template>
  <b-sidebar
    v-if="isSiteLoadDone && (isMobile || !site.isMenuHorizontalStyle)"
    class="vertical-style"
    backdrop
    :visible="isMegaMenuOpen"
    shadow
    no-header
    @change="megaMenuVisibilityChanged"
  >
    <div
      class="menu-content-container"
      :class="{
        'with-social-media-container': !site.isMenuHorizontalStyle && socialList.length > 0,
      }"
    >
      <div
        v-if="isMegaMenuOpen && !menuList"
        class="d-flex align-items-center justify-content-center w-100 h-100"
      >
        <loading-indicator />
      </div>
      <div
        v-else-if="isMegaMenuOpen"
      >
        <div v-if="!isMobile">
          <li
            v-for="menuItem in menuList"
            :key="menuItem.name + '_desktop'"
            class="nav-item"
            :class="{
              'open' : isMenuOpen(menuItem),
            }"
            @mouseover="loadSecondLevel(menuItem)"
            @mouseleave="clearSecondLevel()"
          >
            <div class="nav-link">
              <!-- azért van itt, hogy ha azon van az egér akkor is maradjon ahol kell -->
              <transition name="slide">
                <mega-menu-second-level
                  v-if="isMenuOpen(menuItem)"
                  :is-mobile="false"
                  :menu-item="loadedMenuItem"
                  @loadMenuItem="loadSecondLevel"
                  @closeMegaMenu="megaMenuVisibilityChanged(false)"
                />
              </transition>
              <a
                v-if="menuItem.isOuterLink"
                :href="menuItem.link"
                target="_blank"
                class="h-100 w-100 d-flex align-items-center justify-content-between"
                :class="{
                  'font-weight-bold' : menuItem.style.isBold,
                }"
              >
                {{ menuItem.name }}
                <div v-if="isArrowVisible(menuItem)" class="icon-arrow arrow-right" />
              </a>
              <router-link
                v-else-if="!hasSubMenu(menuItem) && menuItem.link"
                :to="getMenuLink(menuItem)"
                class="h-100 w-100 d-flex align-items-center justify-content-between"
                :class="{
                  'font-weight-bold' : menuItem.style.isBold,
                }"
              >
                {{ menuItem.name }}
                <div v-if="isArrowVisible(menuItem)" class="icon-arrow arrow-right" />
              </router-link>
              <a
                v-else
                class="h-100 w-100 d-flex align-items-center justify-content-between"
                :class="{
                  'only-text': !hasSubMenu(menuItem),
                  'font-weight-bold' : menuItem.style.isBold,
                }"
              >
                {{ menuItem.name }}
                <div v-if="isArrowVisible(menuItem)" class="icon-arrow arrow-right" />
              </a>
            </div>
            <hr>
          </li>
        </div>
        <div v-else>
          <transition name="slide">
            <mega-menu-second-level
              v-if="loadedMenuItem !== null"
              :is-mobile="true"
              :menu-item="loadedMenuItem"
              @clearSecondLevel="clearSecondLevel"
              @loadMenuItem="loadSecondLevel"
              @closeMegaMenu="megaMenuVisibilityChanged(false)"
            />
          </transition>
          <li
            v-if="isLoggedIn"
            class="nav-item d-lg-none d-block"
            :class="{
              'open' : loadedMenuItem !== null && loadedMenuItem.name === profileObject.name,
            }"
            @click="loadSecondLevel(profileObject)"
          >
            <div class="nav-link">
              <a class="h-100 w-100 d-flex align-items-center justify-content-between font-weight-bold">
                <div class="d-flex">
                  <div
                    class="mr-2 position-relative"
                    :class="{
                      'badge-after upper-corner': unreadMessagesCount > 0,
                    }"
                  >
                    <img class="avatar" :src="userAvatar">
                  </div>
                  {{ $t('profilom') }}
                </div>
                <div class="icon-arrow arrow-right" />
              </a>
            </div>
            <hr>
          </li>
          <li
            v-else
            class="nav-item d-lg-none d-block"
            :class="{
              'open' : loadedMenuItem !== null && loadedMenuItem.name === profileObject.name,
            }"
          >
            <router-link
              to="/login"
              class="h-100 w-100 d-flex align-items-center justify-content-between font-weight-bold"
            >
              <div class="d-flex">
                <div class="mega-menu-icon mr-2 login" />
                {{ $t('belepes_vagy_regisztracio') }}
              </div>
              <div class="icon-arrow arrow-right" />
            </router-link>
            <hr>
          </li>
          <li
            v-for="menuItem in menuList"
            :key="menuItem.name + '_mobile'"
            class="nav-item d-lg-none d-block"
            :class="{
              'open' : loadedMenuItem !== null && loadedMenuItem.name === menuItem.name,
            }"
            @click="loadSecondLevel(menuItem)"
          >
            <div class="nav-link">
              <a
                v-if="menuItem.isOuterLink"
                :href="menuItem.link"
                target="_blank"
                class="h-100 w-100 d-flex align-items-center justify-content-between"
                :class="{
                  'font-weight-bold' : menuItem.style.isBold,
                }"
              >
                {{ menuItem.name }}
                <div v-if="isArrowVisible(menuItem)" class="icon-arrow arrow-right" />
              </a>
              <router-link
                v-else-if="!hasSubMenu(menuItem) && menuItem.link"
                :to="getMenuLink(menuItem)"
                class="h-100 w-100 d-flex align-items-center justify-content-between"
                :class="{
                  'font-weight-bold' : menuItem.style.isBold,
                }"
              >
                {{ menuItem.name }}
                <div v-if="isArrowVisible(menuItem)" class="icon-arrow arrow-right" />
              </router-link>
              <a
                v-else
                class="h-100 w-100 d-flex align-items-center justify-content-between"
                :class="{
                  'only-text': !hasSubMenu(menuItem),
                  'font-weight-bold' : menuItem.style.isBold,
                }"
              >
                {{ menuItem.name }}
                <div v-if="isArrowVisible(menuItem)" class="icon-arrow arrow-right" />
              </a>
            </div>
            <hr>
          </li>
          <template v-if="site.isMenuHorizontalStyle">
            <li
              v-for="menuItem in staticMenuList"
              :key="menuItem.name + '_mobileStaticItem'"
              class="nav-item d-lg-none d-block static-item"
            >
              <div class="nav-link">
                <a
                  v-if="menuItem.isOuterLink"
                  :href="menuItem.link"
                  target="_blank"
                  class="h-100 w-100 d-flex align-items-center justify-content-between"
                  :class="{
                    'font-weight-bold' : menuItem.style.isBold,
                  }"
                  v-text="menuItem.name"
                />
                <router-link
                  v-else-if="!hasSubMenu(menuItem) && menuItem.link"
                  :to="getMenuLink(menuItem)"
                  class="h-100 w-100 d-flex align-items-center justify-content-between"
                  :class="{
                    'font-weight-bold' : menuItem.style.isBold,
                  }"
                  v-text="menuItem.name"
                />
              </div>
              <hr>
            </li>
          </template>
        </div>
      </div>
    </div>
    <div
      v-if="!site.isMenuHorizontalStyle && socialList.length > 0"
      class="social-container w-100"
    >
      <div class="h-100 col-12">
        <div id="panel_socialmedia" class="socialmedia h-100 d-flex align-items-center justify-content-around flex-wrap">
          <a
            v-for="(socialIcon, index) in socialList"
            :key="'social-' + socialIcon.name + '-' + index"
            :href="socialIcon.link"
            :title="socialIcon.name"
            target="_blank"
            @click="sendSocialGaEvent(socialIcon.contentType)"
          >
            <div :class="`social-icon ${socialIcon.contentType}`" />
          </a>
        </div>
      </div>
    </div>
  </b-sidebar>
  <div
    v-else
    class="d-flex flex-wrap h-100 horizontal-style"
  >
    <b-carousel
      v-model="currentMenuViewIndex"
      class="w-100"
      :interval="0"
      :controls="menuViewCount !== 1"
      :indicators="false"
      :class="{
        'next-indicator-hidden': currentMenuViewIndex === (menuViewCount - 1),
        'prev-indicator-hidden': currentMenuViewIndex === 0,
      }"
    >
      <b-carousel-slide
        v-for="menuViewIndex in menuViewCount"
        :key="menuViewIndex"
      >
        <template #img>
          <div class="d-flex align-items-center w-100 h-100 pl-4">
            <li
              v-for="menuItem in getCurrentMenuItemsByViewIndex(menuViewIndex)"
              :key="menuItem.name + '_desktop'"
              class="nav-item d-flex align-items-center h-100 cursor-pointer text-uppercase"
              :class="{
                'open' : isMenuOpen(menuItem),
              }"
              @mouseover="loadSecondLevel(menuItem)"
              @mouseleave="clearSecondLevel()"
            >
              <div class="nav-link h-100">
                <!-- azért van itt, hogy ha azon van az egér akkor is maradjon ahol kell -->
                <transition name="slide">
                  <mega-menu-second-level
                    v-if="isMenuOpen(menuItem)"
                    :is-mobile="false"
                    :menu-item="loadedMenuItem"
                    @loadMenuItem="loadSecondLevel"
                    @closeMegaMenu="megaMenuVisibilityChanged(false)"
                  />
                </transition>
                <a
                  v-if="menuItem.isOuterLink"
                  :href="menuItem.link"
                  target="_blank"
                  class="h-100 w-100 d-flex align-items-center justify-content-between text-center"
                  :class="{
                    'font-weight-bold' : menuItem.style.isBold,
                  }"
                >
                  {{ menuItem.name }}
                  <div
                    v-if="hasSubMenu(menuItem)"
                    class="ml-2 icon-arrow"
                    :class="isMenuOpen(menuItem) ? 'mt-1 arrow-up' : 'mb-2 arrow-down'"
                  />
                </a>
                <router-link
                  v-else-if="!hasSubMenu(menuItem) && menuItem.link"
                  :to="getMenuLink(menuItem)"
                  class="h-100 w-100 d-flex align-items-center justify-content-between text-center"
                  :class="{
                    'font-weight-bold' : menuItem.style.isBold,
                  }"
                >
                  {{ menuItem.name }}
                  <div
                    v-if="hasSubMenu(menuItem)"
                    class="ml-2 icon-arrow"
                    :class="isMenuOpen(menuItem) ? 'mt-1 arrow-up' : 'mb-2 arrow-down'"
                  />
                </router-link>
                <a
                  v-else
                  class="h-100 w-100 d-flex align-items-center justify-content-between text-center"
                  :class="{
                    'only-text': !hasSubMenu(menuItem),
                    'font-weight-bold' : menuItem.style.isBold,
                  }"
                >
                  {{ menuItem.name }}
                  <div
                    v-if="hasSubMenu(menuItem)"
                    class="ml-2 icon-arrow"
                    :class="isMenuOpen(menuItem) ? 'mt-1 arrow-up' : 'mb-2 arrow-down'"
                  />
                </a>
              </div>
            </li>
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BCarousel, BCarouselSlide, BSidebar } from 'bootstrap-vue'

export default {
  name: 'MegaMenu',
  components: {
    'loading-indicator': () => import(/* webpackChunkName: "LoadingIndicator" */ '../LoadingIndicator/LoadingIndicator.vue'),
    'mega-menu-second-level': () => import(/* webpackChunkName: "MegaMenuSecondLevel" */ '../MegaMenuSecondLevel/MegaMenuSecondLevel.vue'),
    'b-sidebar': BSidebar,
    'b-carousel': BCarousel,
    'b-carousel-slide': BCarouselSlide,
  },
  props: {
    /**
     * nyitva van-e a menu
     */
    isMegaMenuOpen: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      /**
       * második szintre betöltött menüitem
       */
      loadedMenuItem: null,
      currentMenuViewIndex: 0,
    }
  },
  computed: {
    ...mapGetters({
      menu: 'MegaMenu/getMenu',
      isMenuLoadDone: 'MegaMenu/isMenuLoadDone',
      isMenuLoading: 'MegaMenu/isMenuLoading',
      isLoggedIn: 'User/isLoggedIn',
      site: 'Site/getSite',
      isSiteLoadDone: 'Site/isSiteLoadDone',
      socialList: 'Site/getSocialList',
      userAvatar: 'User/getUserAvatarSrc',
      unreadMessagesCount: 'User/getUnreadMessagesCount',
    }),
    /**
     * hány menu item lesz egyszerre megjelenítve
     */
    menuItemCountForView() {
      if (this.$mq === 'lg') {
        return 3
      }
      if (this.$mq === 'xl') {
        return 4
      }
      if (this.$mq === 'megaMenuLarge') {
        return 5
      }
      return 7
    },
    /**
     * hány menu view kell majd az összes item megjelenítéséhez
     *
     * @return {number}
     */
    menuViewCount() {
      return Math.ceil(this.menuList.length / this.menuItemCountForView)
    },
    personalDetailsObject() {
      return {
        name: this.$t('szemelyes_adatok'),
        key: 'personal-details',
        backAction: 'loadProfile',
      }
    },
    ordersObject() {
      return {
        name: this.$t('rendeleseim'),
        key: 'orders',
        backAction: 'loadProfile',
      }
    },
    favoritesObject() {
      return {
        name: this.$t('menu_shop_kedvencek'),
        key: 'favorites',
        backAction: 'loadProfile',
      }
    },
    messagesObject() {
      return {
        name: this.$t('uzeneteim'),
        key: 'messages',
        backAction: 'loadProfile',
      }
    },
    questionsObject() {
      return {
        name: this.$t('termekkerdeseim'),
        key: 'questions',
        backAction: 'loadProfile',
      }
    },
    profileObject() {
      return {
        name: this.$t('profilom'),
        key: 'profile',
        sub: [
          this.personalDetailsObject,
          this.ordersObject,
          this.favoritesObject,
          this.messagesObject,
          this.questionsObject,
        ],
      }
    },
    /**
     * mobil nézet-e
     *
     * @return {boolean}
     */
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
    /**
     * normál, nem static (szürke zónás) itemek listája
     */
    menuList() {
      return this.menuItems.filter(menuItem => !menuItem.isStaticItem)
    },
    /**
     * static (szürke zónás) itemek listája
     */
    staticMenuList() {
      return this.menuItems.filter(menuItem => menuItem.isStaticItem)
    },
    /**
     * normál, nem static (szürke zónás) itemek listája
     */
    menuItems() {
      if (!this.isMegaMenuOpen) {
        return []
      }
      if (!this.isMenuLoadDone && !this.isMenuLoading) {
        this.loadMenu()
      }
      return this.menu
    },
  },
  created() {
    this.$root.$on('closeMegaMenu', this.clearSecondLevel)
  },
  destroyed() {
    this.$root.$off('closeMegaMenu', this.clearSecondLevel)
  },
  methods: {
    ...mapActions({
      loadMenu: 'MegaMenu/loadMenu',
    }),
    /**
     * jelenlegi viewnak megfelelő számu menu item visszaadása
     *
     * @param menuViewIndex
     * @return {*[]}
     */
    getCurrentMenuItemsByViewIndex(menuViewIndex) {
      const viewIndex = menuViewIndex - 1
      const from = viewIndex * this.menuItemCountForView
      return this.menuList.slice(from, from + this.menuItemCountForView)
    },
    /**
     * ha kapcsolat menüpont akkor loggedIn-tól függően más link kell,
     * egyébként mehet ami van neki
     *
     * @param menuItem
     * @returns {string|*}
     */
    getMenuLink(menuItem) {
      if (menuItem.link.includes('helpdesk') || menuItem.link.includes('profile/messages')) {
        if (!this.isLoggedIn) {
          return '/helpdesk'
        }
        return '/profile?tab=messages'
      }
      return menuItem.link
    },
    /**
     * menuItem van-e nyitva jelenleg
     *
     * @param menuItem
     * @return {boolean}
     */
    isMenuOpen(menuItem) {
      return this.loadedMenuItem && this.loadedMenuItem.name === menuItem.name
    },
    /**
     * mega menü második szint reset
     */
    clearSecondLevel() {
      this.loadedMenuItem = null
    },
    /**
     * mutatjuk-e a nyilat a menüben a menüpontnál
     */
    isArrowVisible(menuItem) {
      return this.hasSubMenu(menuItem) || menuItem.link !== null
    },
    /**
     * menüpontnak van-e submenüje?
     */
    hasSubMenu(menuItem) {
      // ha profil almenüpontot nyitnánk mobilon, akkor azokban van
      if ((menuItem.name === this.profileObject.name) ||
        (menuItem.name === this.personalDetailsObject.name) ||
        (menuItem.name === this.ordersObject.name) ||
        (menuItem.name === this.favoritesObject.name) ||
        (menuItem.name === this.messagesObject.name) ||
        (menuItem.name === this.questionsObject.name)) {
        return true
      }
      return 'sub' in menuItem &&
        (menuItem.sub.length > 0 ||
          'otherBrands' in menuItem.sub ||
          'exclusiveBrands' in menuItem.sub ||
          'skeleton' in menuItem.sub)
    },
    /**
     * mega menü második szint betöltés
     */
    loadSecondLevel(menuItem) {
      if (menuItem === 'profile') {
        this.loadedMenuItem = this.profileObject
        return
      }
      let currentMenuItemToLoad = menuItem
      if ('id' in menuItem) {
        currentMenuItemToLoad = this.menuList.find(item => item.id === menuItem.id)
      }
      if (this.hasSubMenu(currentMenuItemToLoad)) {
        this.loadedMenuItem = currentMenuItemToLoad
      } else {
        this.clearSecondLevel()
      }
    },
    /**
     * mega menü láthatósága változott, ha nem látható bezárjuk miután a második szintet reseteltük
     */
    megaMenuVisibilityChanged(isVisible) {
      if (!isVisible) {
        this.clearSecondLevel()
        this.$emit('closeMegaMenu')
      }
    },
    /**
     * social event GA küldése
     *
     * @param key
     */
    sendSocialGaEvent(key) {
      ga('send', 'event', 'Click', 'Kikattintás', key)
    },
  },
}
</script>

<style scoped lang="scss" src="./MegaMenu.scss" />
